import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbAccordionConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { Desc2Heading, Naics ,Desc3Heading} from 'app/shared/models/naics.model';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';

@Component({
    selector: 'jhi-naics-select',
    templateUrl: './naics-select.component.html',
    styleUrls: ['./naics-select.component.scss']
})
export class NaicsSelectComponent implements OnInit {

    @Input() fc:TRCFundClasses[]=[]
    @Input() type = ""
    @Input() parentEappForm :any
    @Output() pNaicsCd = new EventEmitter<{naic:string,sic:string}>();
    @Output() sNaicsCd = new EventEmitter<{naic:string,sic:string}>();
    naicsCodeSelected = ""
    sicsCodeSelected=""
    errorSelectNaics  = ""
	errorSelectSic  = ""
	


    modelRef: any
    @ViewChild('content') naicsContent: any;
    pgHeader = "Select Primary NAICS Code"
    naicsData: Naics[] = []
    constructor(private config: NgbAccordionConfig, private modalService: NgbModal, private _busRegService: BussinessRegAppService) {
        config.closeOthers = true;
    }
    ngOnInit(): void {
        const temp="eappreg"
    }

    naicsSelected(naicsCd: string,sicCode: string): void {
        // pNaicsCd
        this.errorSelectNaics  = ""
        this.naicsCodeSelected = naicsCd
        this.sicsCodeSelected = sicCode
       
    }

  sicsSelected(sicsCd: string): void {
        // pNaicsCd
        this.errorSelectSic  = ""
        this.sicsCodeSelected = sicsCd
     
    }

    open(type: string): void {
        this.errorSelectNaics  = ""
        this.errorSelectSic  = ""
        if (this.type === "P") {
            this.pgHeader = "Select Primary NAICS Code"
        } else if (this.type === "S") {
            this.pgHeader = "Select Secondary NAICS Code"
        }
        this._busRegService.getNAICS(this.fc).subscribe((res: any) => {
            this.naicsData =[]
            const data = res
            let prev_hdr1 = ''
            let prev_hdr2 = ''
            let prev_hdr3=''
			let prev_hdr4=''
			let naisCode=''
		    let obj: Naics = new Naics("", [])

            let obj2: Desc2Heading = new Desc2Heading("", [])
            let obj3: Desc3Heading = new Desc3Heading("", "","","")

            for (let i = 0; i < data.length; i++) {
                if (data[i].desc_1 !== prev_hdr1) {
                    prev_hdr1 = data[i].desc_1
                    obj = new Naics("", [])
                
                    obj.desc1Heading = data[i].desc_1
                    this.naicsData.push(obj)

                }


                if (data[i].desc_2 !== prev_hdr2) {
                    prev_hdr2 = data[i].desc_2
                    obj2 = new Desc2Heading("", [])
                    obj2.desc2Heading = data[i].desc_2
                    obj.desc2Array.push(obj2)


                }
                if (data[i].desc_3 !== prev_hdr3 && naisCode !== data[i].naicCode) {
                    prev_hdr3 = data[i].desc_3
					prev_hdr4 = data[i].sicCode
                    obj3 = new Desc3Heading("", "","","")
                    obj3.desc3Heading = data[i].desc_3
                    obj3.naicCode=data[i].naicCode
					naisCode = data[i].naicCode
                    obj2.desc3Array.push(obj3)
 					obj3.desc4= (data[i].desc_4)
                	obj3.sicCode=(data[i].sicCode)
                }
				else if ( (data[i].desc_1 === prev_hdr1) && (data[i].desc_2 === prev_hdr2) && (data[i].naicCode === naisCode ) && (prev_hdr4 !== data[i].sicCode)) {
                     prev_hdr3 = data[i].desc_3
					prev_hdr4 = data[i].sicCode
                    obj3 = new Desc3Heading("", "","","")
                    obj3.desc3Heading = data[i].desc_3
                    obj3.naicCode=data[i].naicCode
					naisCode = data[i].naicCode
                    obj2.desc3Array.push(obj3)
 					obj3.desc4= (data[i].desc_4)
                	obj3.sicCode=(data[i].sicCode)
                }

                
                
            }
        }, () => {
            // empty
        }, () => {
            this.modelRef = this.modalService.open(this.naicsContent, { scrollable: true, size: 'xl', backdrop: 'static', keyboard: false })
        })


    }
    cancel(): void {
        this.errorSelectNaics  = ""
        this.naicsCodeSelected = ""
        this.errorSelectSic  = ""
        this.sicsCodeSelected = ""

        this.modelRef.close()
    }
    submit(): void {
        this.errorSelectNaics  = ""
        this.errorSelectSic  = ""
        if (this.naicsCodeSelected !== "" && this.sicsCodeSelected !=="") {
            if (this.type === "P") {
                this.pNaicsCd.emit({naic:this.naicsCodeSelected,sic:this.sicsCodeSelected})
            }
            if (this.type === "S") {
                this.sNaicsCd.emit({naic:this.naicsCodeSelected,sic:this.sicsCodeSelected})
            }
            this.modelRef.close()
        } else {
            // alert("please select any one")
            if(this.naicsCodeSelected==="" && this.sicsCodeSelected!==""){
	this.errorSelectNaics  = "Please select your NAICS code."
}
else if(this.naicsCodeSelected!=="" && this.sicsCodeSelected===""){this.errorSelectSic  = "Please select your SIC code."
}
else{
	this.errorSelectNaics  = "Please select your NAICS code."
	this.errorSelectSic  = "Please select your SIC code."
}
            
			
        }
    }

}
